module.exports = __webpack_public_path__ + "static/media/challenge_newbie.104055a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/challenge_newbie.png
// module id = 1063
// module chunks = 0